import { render, staticRenderFns } from "./GlobalLabel.vue?vue&type=template&id=3c3939e7&"
import script from "./GlobalLabel.vue?vue&type=script&lang=js&"
export * from "./GlobalLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports